import React, {Suspense, useMemo, useRef, useEffect, useState, useCallback} from 'react';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { useLoader, useFrame } from "@react-three/fiber";
import SystemConfiguration from 'settings/SystemConfiguration';
import * as THREE from "three";

import PointShader from "shader/PointShader"
import PointCloud from './PointCloud';
import TriangleMesh from './TriangleMesh';

import $ from 'jquery'

const vertexShader = PointShader.vertexShader
const fragmentShader = PointShader.fragmentShader


function Mesh (props){
    var isPointCloud = props.file_name.split("_").at(-1) == "pc"


    // check if mesh exists
    // var objd = useLoader(OBJLoader, process.env.PUBLIC_URL + '/' + props.file_name +'.obj')
    // if(objd.children.length == 0) {
    //     console.log("error")
    //     $("#rightpanel_header").html("File does not exist").css("color", "red")
    //     return (
    //         <group>
    //             empty
    //         </group>
    //     )
    // }

    return (
        <>
            {isPointCloud ? (
                <PointCloud file_name={props.file_name}/>
            ) : (
                <TriangleMesh file_name={props.file_name}/>
            )}
        </>
    );




    
}

export default Mesh;